/**
 * How long a generated trading (signing) key lives. One source for the expiry
 * useRegister signs and for the Remember Me copy that describes it (#32: the
 * UI never said an unticked box meant a 1-hour session).
 */
export const SIGNING_KEY_TTL = {
  /** Remember Me ticked. */
  remembered: { days: 7 },
  /** Remember Me unticked. */
  session: { hours: 1 },
} as const;
